
import { Button } from "@/components/ui/button";
import { Flashlight, Square } from "lucide-react";

interface ScannerControlsProps {
  isScanning: boolean;
  torchEnabled: boolean;
  onSimulateScan: () => void;
  onToggleTorch: () => void;
  onStopScanning: () => void;
}

export const ScannerControls = ({
  isScanning,
  torchEnabled,
  onSimulateScan,
  onToggleTorch,
  onStopScanning
}: ScannerControlsProps) => {
  if (!isScanning) return null;

  return (
    <div className="flex gap-2">
      <Button onClick={onSimulateScan} variant="outline" className="flex-1">
        Simulate Scan
      </Button>
      <Button 
        onClick={onToggleTorch} 
        variant="outline" 
        size="sm"
        className="px-3"
      >
        <Flashlight className={`w-4 h-4 ${torchEnabled ? 'text-yellow-500' : ''}`} />
      </Button>
      <Button onClick={onStopScanning} variant="outline" className="flex-1">
        <Square className="w-4 h-4 mr-2" />
        Stop
      </Button>
    </div>
  );
};
